var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "progress-title" }, [
        _vm._v("\n    move timeline\n  ")
      ]),
      _vm._v(" "),
      _vm.statusLogs && _vm.statusLogs.length && _vm.uniqueLogs
        ? [
            _c(
              "div",
              { staticClass: "circles-wrap pl-2" },
              _vm._l(_vm.uniqueLogs, function(status) {
                return _c(
                  "div",
                  {
                    key: status.status_id,
                    staticClass:
                      "progress-section d-flex justify-content-between align-items-center"
                  },
                  [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("div", {
                        staticClass: "mr-4",
                        class:
                          status.status_id === _vm.statusId &&
                          status.status_id !== 16
                            ? "marker-0"
                            : "marker-green"
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "progress-status d-flex flex-column" },
                        [
                          status.status_id === _vm.statusId &&
                          status.status_id !== 16
                            ? _c("span", { staticClass: "progress-text" }, [
                                _vm._v(
                                  "\n              At this moment\n            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "progress-text-secondary",
                              class: {
                                "text-gray":
                                  status.status_id !== _vm.statusId ||
                                  _vm.statusId === 16
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(status.status.name) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "progress-time" }, [
                      _vm._v(_vm._s(_vm.formatDate(status.created_at)))
                    ])
                  ]
                )
              })
            )
          ]
        : _c(
            "div",
            {
              staticClass:
                "progress-section d-flex justify-content-between align-items-center"
            },
            [
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c("div", { staticClass: "marker-0 mr-4" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "progress-status d-flex flex-column" },
                  [
                    _c("span", { staticClass: "progress-text" }, [
                      _vm._v("At this moment")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "progress-text-secondary" }, [
                      _vm._v(_vm._s(_vm.statusName))
                    ])
                  ]
                )
              ])
            ]
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0bef5750", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bef5750","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobInProgressMoveTimeline.vue
// module id = null
// module chunks = 